import React from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';

import { Card, CardBody, CardFooter, Row, Col, FormGroup, Label, Button } from 'reactstrap';

import FaSearch from 'react-icons/lib/fa/search';
import FaClose from 'react-icons/lib/fa/close';
import IconExport from 'react-icons/lib/fa/file-excel-o';
import Entity from '../../MasterData/Entity';

import EmployeeSelect from '../../ReduxForm/EmployeeSelect';
import LocationSelect from '../../ReduxForm/LocationSelect';
import TypeSelect from './TypeSelect';
import Input from '../../ReduxForm/Input';
import Checkbox from '../../ReduxForm/Checkbox';
import DatePicker from '../../ReduxForm/DatePicker';

import LoadingButton from '../../Helpers/LoadingButton';
import { selectLegacyUser } from '../../../Modules/auth/selectors';
import { exportDataRequest } from '../../Export/hooks';

const int = (value) => parseInt(value, 10);

const EXPORT_TYPE_CUSTOMER_LEADS = 'customerleads';
const EXPORT_TYPE_CUSTOMER_SEARCH = 'customersearch';
const formKey = 'customer-search';

class CustomerSearchForm extends Entity {
    handleReset() {
        const { onReset, initialize, criteria } = this.props;
        onReset();
        initialize(criteria);
    }

    renderExportButton() {
        const { currentUser, exportSearch, criteria } = this.props;

        if (
            currentUser.role !== 'Usergroup10' &&
            currentUser.role !== 'Usergroup8' &&
            currentUser.role !== 'Usergroup6' &&
            currentUser.role !== 'Usergroup4'
        ) {
            return null;
        }

        return (
            <span>
                <LoadingButton onClick={() => exportSearch(criteria)} id="exportsearch">
                    <IconExport />
                    &nbsp;Exportieren
                </LoadingButton>
                {' | '}
            </span>
        );
    }

    renderLeadsFilter() {
        const { currentUser } = this.props;
        // either LeadGroup2 or LeadGroup3 or locationId 8 (HQ)
        if (currentUser.location.leadGroup !== "Leadgruppe2" && currentUser.location.leadGroup !== "Leadgruppe3" && currentUser.locationId !== 8)
            return;

        return (
            <div>
                <FormGroup className="ml-4 mt-4">
                    <Label>
                        <Field name="leads_chargeable" component={Checkbox} />
                        &nbsp;Kostenpflichtige Leads
                    </Label>
                </FormGroup>
                <FormGroup>
                    <Label className="text-nowrap">Zeitraum</Label>
                    <Row style={{ marginLeft: 0 }}>
                        <Col style={{ flexGrow: '2.5' }}>
                            <FormGroup
                                row
                                color={this.getFieldState('receivedAt[from]')}
                            >
                                <Label>von</Label>
                                <Col>
                                    <Field
                                        name="receivedAt[from]"
                                        component={DatePicker}
                                    />
                                    {this.getFieldFeedback('receivedAt[from]')}
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col style={{ flexGrow: '2.5' }}>
                            <FormGroup row>
                                <Label>bis</Label>
                                <Col>
                                    <Field
                                        name="receivedAt[till]"
                                        component={DatePicker}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </FormGroup>
            </div>
        );
    }

    render() {
        //const { criteria, handleSubmit, onSubmit } = this.props;
        const { handleSubmit, onSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Card id={formKey} className="hide-on-print" data-cy="card-customersearch">
                    <h6 className="card-header">Kundensuche</h6>
                    <CardBody>
                        {this.renderEntityAlerts()}
                        <Row>
                            <Col sm="auto" lg="4">
                                <fieldset>
                                    <legend>Kontakt</legend>
                                    <FormGroup>
                                        <Label>Vorname, Nachname</Label>
                                        <Field name="name" component={Input} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Adresse</Label>
                                        <Field name="address" component={Input} />
                                    </FormGroup>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label>PLZ</Label>
                                                <Field name="zip" component={Input} />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label>Ort</Label>
                                                <Field name="city" component={Input} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <FormGroup>
                                        <Label>Telefon</Label>
                                        <Field name="phone" component={Input} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>E-Mail</Label>
                                        <Field name="email" component={Input} />
                                    </FormGroup>
                                </fieldset>
                            </Col>
                            <Col sm="auto">
                                <fieldset>
                                    <legend>Kunde</legend>
                                    <FormGroup>
                                        <Label>Auftragsnummer</Label>
                                        <Field name="id" component={Input} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Status</Label>
                                        <Field name="type" component={TypeSelect} />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>zugewiesener Mitarbeiter</Label>
                                        <Field
                                            name="employee"
                                            component={EmployeeSelect}
                                            normalizer={int}
                                            group
                                            filterBy={(e) => e.team !== null}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Standort</Label>
                                        <Field
                                            name="location"
                                            component={LocationSelect}
                                            normalizer={int}
                                        />
                                    </FormGroup>
                                    <FormGroup className="ml-4 mt-4">
                                        <Label>
                                            <Field name="vip" component={Checkbox} />
                                            &nbsp;VIP
                                        </Label>
                                    </FormGroup>
                                    <FormGroup className="ml-4 mt-4">
                                        <Label>
                                            <Field name="premium" component={Checkbox} />
                                            &nbsp;Premium
                                        </Label>
                                    </FormGroup>
                                    <FormGroup className="ml-4 mt-4">
                                        <Label>
                                            <Field name="has_filed_complaint" component={Checkbox} />
                                            &nbsp;Reklamation
                                        </Label>
                                    </FormGroup>
                                    {this.renderLeadsFilter()}
                                </fieldset>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        {this.renderExportButton()}
                        <Button onClick={() => this.handleReset()} data-cy="reset">
                            <FaClose />
                            &nbsp;Zurücksetzen
                        </Button>{' '}
                        <Button color="primary" type="submit" data-cy="submit">
                            <FaSearch />
                            &nbsp;Suchen
                        </Button>
                    </CardFooter>
                </Card>
            </Form>
        );
    }
}

CustomerSearchForm = reduxForm({ form: formKey })(CustomerSearchForm);

const mapStateToProps = (state) => {
    const { criteria, loadError } = state.customerSearch;

    return {
        criteria,
        enableReinitialize: true,
        initialValues: criteria,
        currentUser: selectLegacyUser(state),
        error: loadError,
        saveError: loadError,
        saveSuccess: false,
    };
};

const mapDispatchToProps = (dispatch) => ({
    exportSearch: (criteria) => {
        // check if in the criteria we have type 'leads'
        if (!criteria || criteria.leads_chargeable !== true) {
            // instead of dispatching the promise directly, we dispatch a function (thunk).
            return dispatch(() => {
                // the thunk executes the promise.
                exportDataRequest(EXPORT_TYPE_CUSTOMER_SEARCH, criteria);
            });
        }
        // instead of dispatching the promise directly, we dispatch a function (thunk).
        return dispatch(() => {
            // The thunk executes the promise.
            exportDataRequest(EXPORT_TYPE_CUSTOMER_LEADS, criteria);
        });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSearchForm);
